import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import {
  getLoggedinSuperAdmin,
  setAuthorization,
} from "../helpers/api_helper";

/**
 * Guard das rotas `/super-admin/*` autenticadas.
 * Usa só `sa_authUser` — nunca o JWT tenant (DOC 09 § 4).
 */
const SuperAdminProtected = (props: any) => {
  const [session, setSession] = useState(() => getLoggedinSuperAdmin());

  useEffect(() => {
    const current = getLoggedinSuperAdmin();
    setSession(current);
    const token = current?.access_token || current?.token;
    if (token) {
      setAuthorization(token);
    }
  }, []);

  const token = session?.access_token || session?.token;
  if (!session || !token) {
    return <Navigate to="/super-admin/login" replace />;
  }

  return <>{props.children}</>;
};

export default SuperAdminProtected;
